import type { PropsWithChildren } from "react";

import {
  type FieldErrors,
  type FieldValues,
  useFormContext,
} from "react-hook-form";

export type FormElementProps<FormValues extends FieldValues> =
  PropsWithChildren<{
    onSubmitInvalidData?: (errors: FieldErrors<FormValues>) => void;
    onSubmitValidData?: (data: FormValues) => void;
  }>;

export const FormElement = <FormValues extends FieldValues>({
  children,
  onSubmitInvalidData,
  onSubmitValidData,
}: FormElementProps<FormValues>) => {
  const { handleSubmit } = useFormContext<FormValues>();
  return (
    <form
      noValidate
      onSubmit={
        onSubmitValidData !== undefined
          ? handleSubmit(onSubmitValidData, onSubmitInvalidData)
          : undefined
      }
    >
      {children}
    </form>
  );
};
